import React from 'react';
import './LoadSpinner.css';

const LoadSpinner = () => (
  <div className="loader"></div>
);

export default LoadSpinner;